import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { sectionListType } from '../types/TeacherSchedule';
import { TranslationsKeys } from '../../../locales/translations';

type UseSectionsColumnsProps = {
  setSectionDetail: (section: sectionListType[]) => void;
};
export const useSectionsColumns = ({
  setSectionDetail,
}: UseSectionsColumnsProps) => {
  const { t } = useTranslation(TranslationsKeys.TEACHER_SCHEDULE);

  const columns = useMemo<ColumnTable<sectionListType>[]>(
    () => [
      {
        columnName: 'sectionName',
        headerText: t(`section`),
      },
      {
        columnName: 'courseName',
        headerText: t(`course`),
      },
      {
        columnName: 'teachers',
        headerText: t(`teacher`),
        cellFormat: ({ row }) =>
          row.teachers.map((name, index) => (
            <div key={index}>
              <span>{name}</span>
              <br />
            </div>
          )),
      },
      {
        columnName: 'sectionName',
        headerText: '',
        cellFormat: ({ row }) => (
          <div
            className="cursor-pointer"
            onClick={() => {
              setSectionDetail([row]);
            }}
          >
            <Icon name="chevron_right" />
          </div>
        ),
      },
    ],
    [t, setSectionDetail],
  );

  return columns;
};
